import React from "react";
import { Application } from "../../../interfaces/data";
import { Input } from "../../../components/Input/Input";
import { TwoColumnsLayout } from "../../../components/TwoColumnsLayout/TwoColumnsLayout";
import { useTranslation } from "react-i18next";
import { EditViewProps } from "../../../components/EditBox/EditBox";
import { LEGAL_ENTITIES } from "../../../helpers/options";
import { Select } from "../../../components/Select/Select";

export function EditCompanyInfo({ data, handleChange, errors }: EditViewProps<Application>) {
  const { t } = useTranslation();

  if (!data) {
    return null;
  }

  return (
    <TwoColumnsLayout>
      <Input
        error={errors?.name}
        id="name"
        label={t("application:Name")}
        name="name"
        onChange={handleChange}
        type="text"
        value={data.name}
        withError={!!errors?.name}
      />
      <Select
        error={errors?.legalEntity}
        id="legalEntity"
        label={t("application:Legal entity")}
        name="legalEntity"
        onChange={handleChange}
        options={LEGAL_ENTITIES}
        value={data.legalEntity}
      />
      <Input
        error={errors?.nip}
        id="nip"
        label={t("application:NIP")}
        name="nip"
        onChange={handleChange}
        type="text"
        value={data.nip}
        withError={!!errors?.nip}
      />
      <Input
        error={errors?.regon}
        id="regon"
        label={t("application:REGON")}
        name="regon"
        onChange={handleChange}
        type="text"
        value={data.regon}
        withError={!!errors?.regon}
      />
      <Input
        error={errors?.krs}
        id="krs"
        label={t("application:KRS")}
        name="krs"
        onChange={handleChange}
        type="text"
        value={data.krs}
        withError={!!errors?.krs}
      />
      <Input
        error={errors?.phone}
        id="phone"
        label={t("application:Phone")}
        name="phone"
        onChange={handleChange}
        type="text"
        value={data.phone}
        withError={!!errors?.phone}
      />
    </TwoColumnsLayout>
  );
}
